export default __webpack_public_path__ + "static/media/PLW.ebc8fb3e.svg";